// Hur signalernas värden visas i appen.

import { type Signalvarde, tal } from "@batkoll/gemensam";

export const LADDLAGE: Record<string, string> = {
  av: "Av",
  vila: "Vila",
  bulk: "Bulk",
  absorption: "Absorption",
  float: "Underhåll",
  laddar: "Laddar",
  fel: "Fel",
  okant: "Okänt",
};

export const AC_KALLA: Record<string, string> = {
  land: "Landström",
  generator: "Generatorn",
  vaxelriktare: "Växelriktaren",
  ingen: "Ingen 230 V",
  okant: "Okänt",
};

/** Ett värde äldre än så här visas som gammalt. */
export const GAMMALT_MS = 15 * 60_000;

export function tal1(v: unknown, enhet: string, decimaler = 1): string {
  return typeof v === "number" ? `${tal(v, decimaler)} ${enhet}` : "–";
}

export function jaNej(v: unknown, ja = "Ja", nej = "Nej"): string {
  return v === true ? ja : v === false ? nej : "–";
}

/** Grader och minuter, till exempel 57°40,18′ N. */
export function koordinat(grader: number, positiv: string, negativ: string): string {
  const g = Math.abs(grader);
  const hela = Math.floor(g);
  const minuter = (g - hela) * 60;
  return `${hela}°${tal(minuter, 2).padStart(5, "0")}′ ${grader >= 0 ? positiv : negativ}`;
}

export function position(v: unknown): string {
  if (typeof v !== "object" || v === null) return "–";
  const p = v as { lat: number; lon: number };
  return `${koordinat(p.lat, "N", "S")}  ${koordinat(p.lon, "E", "W")}`;
}

export function arGammalt(s: Signalvarde | undefined, nu: number): boolean {
  return s !== undefined && nu - s.tid > GAMMALT_MS;
}
